import { t } from 'i18next';

import { DepartmentType } from '@/services/api/codegen/api';

export const departmentLabel = (value: string = '') => {
  switch (value) {
    case DepartmentType.Sales:
      return t('components:board.sales');
    case DepartmentType.Marketing:
      return t('components:board.marketing');
    case DepartmentType.HumanResources:
      return t('components:board.humanResources');
    case DepartmentType.InformationTechnologies:
      return t('components:board.informationTechnologies');
    case DepartmentType.Finance:
      return t('components:board.finance');
    case DepartmentType.ProductAndDesign:
      return t('components:board.productAndDesign');
    case DepartmentType.OperationsAndCustomerSupport:
      return t('components:board.operationsAndCustomerSupport');
    case DepartmentType.Legal:
      return t('components:board.legal');
    case DepartmentType.RnD:
      return t('components:board.rN');
    case DepartmentType.Quality:
      return t('components:board.quality');
    case DepartmentType.Production:
      return t('components:board.production');
    case DepartmentType.ManagementOrStrategy:
      return t('components:board.managementOrStrategy');
    case DepartmentType.Logistics:
      return t('components:board.logistics');
    default:
      return value;
  }
};
